var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{class:`iconfont icon-${_vm.type}`,style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }